

function parseData(data) {
  if ((!data) || data.length == 0) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {

  const getUserIdDetails = ({ inputParam, metaData }) =>
    api
      .getUserIdDetails(inputParam, metaData)
      .then(parseData);

  const getSmartCardURL = ({ metaData }) =>
    api
      .getSmartCardURL(metaData)
      .then(parseData);

  const clearOtherSession = ({ inputParam, metaData }) =>
    api
      .clearOtherSession(inputParam, metaData)
      .then(parseData);

  const smartCardLoginFailed = ({ inputParam, metaData }) =>
    api
      .smartCardLoginFailed(inputParam, metaData)
      .then(parseData);

  return {
    getUserIdDetails,
    getSmartCardURL,
    clearOtherSession,
    smartCardLoginFailed
  }
}

module.exports = serviceFactory;
